import { postFetch } from '../fetch';
import { apiConfig } from '../config';
import { CRITERIA_MARK_VALUE } from './get-criteria-marks';

interface PutCriteriaMarksParams {
    criterion_id: string;
    attempt_id: string;
    object_type?: 'problem';
    object_id: string;
    value: CRITERIA_MARK_VALUE;
}

export function putCriteriaMarks(params: PutCriteriaMarksParams): Promise<void> {
    const { apiPutCriteriaMarks } = apiConfig.getStaticUrls();

    return postFetch(apiPutCriteriaMarks, { object_type: 'problem', ...params });
}
